/*
 *###############################################################################
 *Module Name                   : VoucherRequestController.js                   #
 *Purpose of the Module         :                                               #
 *Description of the Module     :                                               #
 *Original Author               :  W M Shanika Chamodi                          #
 *Date                          : Friday, October 1st 2021, 3:20:00 pm          #
 *Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
 *###############################################################################
 */

import React, { useState } from "react"
import { Row, Col, Button, Label } from "reactstrap"
import DPTextBoxforgrid from "../../../framework/components/DPTextBoxforgrid"
import DPAlert from "../../../framework/widgets/DPAlert"
import { Numeric } from "../../../framework/validators/TextValidation" // Textbox input validations
import { loadPopupSearchPay } from "../../../framework/validators/SearchColumn"
import DPSearchBoxDynamicHeadOffice from "framework/components/DPSearchBoxDynamicHeadOffice"
const VoucherRequestDetails = ({
  DataRow,
  RemoveRow,
  BookChange,
  AddRow,
  TotalBookQty,
  TotalSellingValue,

  NetAmount,

  rowsTax,
  SupplierCode,
  blDiasableGrid,
  menuCode,
  setGridRows,
  SupplierTax,
  setSupplierTax,
  setTax,
  SetLoadingAlert,
  SetLoadingAlerttitle
}) => {


  const [detailSearchCol, setdetailSearchCol] = useState([])

  React.useEffect(async () => {
    setdetailSearchCol(await loadPopupSearchPay(menuCode, "VOUGRP"))
  }, [menuCode])


  function HandleRowChanges(value, index, field) {
    let rows = [...DataRow]
    rows[index][field] = value
    setGridRows(rows)
  }

  function HandleTaxRowChange(index, code, costValue) {

    let row = []
    let TaxRows = [...rowsTax]

    row = rowsTax.filter((row) => row.code == code)

    if (row.length > 0) {

      row.map((item, index) => {
        var newItem = item
        newItem.grossAmt = costValue
        if (item.isInclude == 1) {
          var TaxIncAmt = parseFloat(parseFloat(costValue) * parseFloat(item.TaxRate) / (100 + parseFloat(item.TaxRate))).toFixed(2)
          newItem.TaxAmount = TaxIncAmt
        } else {
          var TaxExAmt = parseFloat(parseFloat(costValue) * parseFloat(item.TaxRate) / 100).toFixed(2)
          newItem.TaxAmount = TaxExAmt
        }

        let indexRow = rowsTax.findIndex((row) => row.code == code && row.TaxCode == item.TaxCode)

        TaxRows[indexRow] = newItem

      })

      setTax(TaxRows)
    }
  }

  return (
    <React.Fragment>
      <Row>
        <Col sm={12} md={12} className="mb-12-sm">
          <table style={{ fontSize: "11px" }} id={"VoucherPODet"}>
            <thead className="table-light">
              <tr>
                <th>#</th>
                <th style={{ textAlign: "left" }}>Voucher Group</th>
                <th>&nbsp;</th>
                <th style={{ textAlign: "left" }}>Group Description </th>
                {/* <th style={{ textAlign: "right" }}>Cost</th> */}
                <th style={{ textAlign: "right" }}>Selling (Per Voucher)</th>
                {/* <th style={{ textAlign: "right" }}>Starting Book No.</th> */}
                <th style={{ textAlign: "right" }}>No. of Books</th>
                {/* <th style={{ textAlign: "right" }}>Ending Book No.</th> */}
                {/* <th style={{ textAlign: "right" }}>Cost Value</th> */}
                <th style={{ textAlign: "right" }}>Selling Value</th>
              </tr>
            </thead>
            <tbody>
              {(DataRow || []).map((formRow, key) => (
                <TableRow
                  FormRow={formRow}
                  Key={key}
                  RemoveRow={RemoveRow}
                  Disabled={blDiasableGrid}
                  BookChange={BookChange}
                  SupplierCode={SupplierCode}
                  detailSearchCol={detailSearchCol}
                  menuCode={menuCode}
                  HandleRowChanges={HandleRowChanges}
                  DataRow={DataRow}
                  rowsTax={rowsTax}
                  SupplierTax={SupplierTax}
                  setSupplierTax={setSupplierTax}
                  setTax={setTax}
                  HandleTaxRowChange={HandleTaxRowChange}
                  AddRow={AddRow}
                  SetLoadingAlerttitle={SetLoadingAlerttitle}
                  SetLoadingAlert={SetLoadingAlert}
                />
              ))}
            </tbody>
            <tfoot>
              <tr>
                <th>&nbsp;</th>
                <th style={{ textAlign: "center" }}>&nbsp;</th>
                <th>&nbsp;</th>
                <th style={{ textAlign: "center" }}>&nbsp;</th>
                {/* <th style={{ textAlign: "center" }}>&nbsp;</th>
                <th style={{ textAlign: "center" }}>&nbsp;</th> */}
                <th style={{ textAlign: "left" }}>Total</th>
                <th style={{ textAlign: "right" }}><DPTextBoxforgrid
                  rowClass="mb-12-sm"
                  labelText="Code"
                  textType="text"
                  maxLength="8"
                  textAlign="right"
                  disabled={true}
                  value={TotalBookQty}

                ></DPTextBoxforgrid></th>
                {/* <th style={{ textAlign: "center" }}>&nbsp;</th> */}
                {/* <th style={{ textAlign: "right" }}><DPTextBoxforgrid
                  rowClass="mb-12-sm"
                  labelText="Code"
                  textType="text"
                  maxLength="8"
                  textAlign="right"
                  disabled={true}
                  value={TotalCostValue}
                ></DPTextBoxforgrid></th> */}
                <th style={{ textAlign: "right" }}>
                  <DPTextBoxforgrid
                    rowClass="mb-12-sm"
                    labelText="Code"
                    textType="text"
                    maxLength="8"
                    textAlign="right"
                    disabled={true}
                    value={TotalSellingValue}
                  ></DPTextBoxforgrid>
                </th>
              </tr>
            </tfoot>
          </table>
          <Button
            onClick={() => {
              var emptyRow = DataRow.filter((row) => row.code == "")
              if (emptyRow.length == 0) {
                AddRow()
              }
            }}
            disabled={blDiasableGrid}
            color="success"
            className="mt-1"
            size="sm"
          >
            <i className="mdi mdi-hospital" style={{ fontSize: "12px" }}></i>
          </Button>
        </Col>
        <Col sm={12} md={7} className="mb-12-sm">
          {/* {ShowTaxTable ? (
            <table style={{ fontSize: "11px" }} id={"TaxDet"}>
              <thead className="table-light">
                <tr>
                  <th style={{ textAlign: "left" }}>Voucher Group</th>
                  <th style={{ textAlign: "left" }}>Group Description </th>
                  <th style={{ textAlign: "left" }}>Tax</th>
                  <th style={{ textAlign: "right" }}>Gross Amount</th>
                  <th style={{ textAlign: "right" }}>Tax Rate</th>
                  <th style={{ textAlign: "left" }}>Is Inclusive</th>
                  <th style={{ textAlign: "right" }}>Tax Amount</th>
                </tr>
              </thead>
              <tbody>
                {(rowsTax || []).map((formRow, key) => (
                  <TableTaxRow FormRow={formRow} Key={key} />
                ))}
              </tbody>
            </table>
          ) : null} */}

        </Col>
        <Col sm={12} md={5} className="mb-12-sm">
          {/* <Row>
            <Col sm={6}>
              <Label htmlFor="example-text-input">
                <Label
                  htmlFor="example-text-input"
                  className={`col-md-12 col-form-label-sm`}
                >
                  Gross Amount
                </Label>
              </Label>
            </Col>
            <Col sm={6} style={{ textAlign: "right" }}>
              <DPTextBoxforgrid
                rowClass="mb-12-sm"
                labelText="Code"
                textType="text"
                maxLength="8"
                disabled={true}
                textAlign="right"
                value={GrossAmount}
              ></DPTextBoxforgrid>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Label htmlFor="example-text-input">
                <Label
                  htmlFor="example-text-input"
                  className={`col-md-12 col-form-label-sm`}
                >
                  Discount(%)
                </Label>
              </Label>
            </Col>
            <Col sm={6} style={{ textAlign: "right" }}>
              <DPTextBoxforgrid
                rowClass="mb-12-sm"
                labelText="Code"
                textType="text"
                maxLength="8"
                textAlign="right"
                disabled={blDiasableGrid}
                value={DiscountPer}
                onChange={DiscountPer_OnChange}
                onBlur={DiscountPer_OnBlur}
              ></DPTextBoxforgrid>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Label htmlFor="example-text-input">
                <Label
                  htmlFor="example-text-input"
                  className={`col-md-12 col-form-label-sm`}
                >
                  Additions
                </Label>
              </Label>
            </Col>
            <Col sm={6} style={{ textAlign: "right" }}>
              <DPTextBoxforgrid
                rowClass="mb-12-sm"
                labelText="Code"
                textType="text"
                maxLength="8"
                textAlign="right"
                disabled={blDiasableGrid}
                value={AddAmount}
                onChange={AddAmount_OnChange}
                onBlur={AddAmount_OnBlur}
              ></DPTextBoxforgrid>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Label htmlFor="example-text-input">
                <Label
                  htmlFor="example-text-input"
                  className={`col-md-12 col-form-label-sm`}
                >
                  Deductions
                </Label>
              </Label>
            </Col>

            <Col sm={6} style={{ textAlign: "right" }}>
              <DPTextBoxforgrid
                rowClass="mb-12-sm"
                labelText="Code"
                textType="text"
                maxLength="8"
                textAlign="right"
                disabled={blDiasableGrid}
                value={DedAmount}
                onChange={DedAmount_OnChange}
                onBlur={DedAmount_OnBlur}
              ></DPTextBoxforgrid>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Label htmlFor="example-text-input">

                <Label
                  htmlFor="example-text-input"
                  className={`col-md-12 col-form-label-sm`}
                >
                  Tax(Inclusive)
                </Label></Label>
            </Col>
            <Col sm={6} style={{ textAlign: "right" }}>
              <DPTextBoxforgrid
                rowClass="mb-12-sm"
                labelText="Code"
                textType="text"
                maxLength="8"
                disabled={true}
                textAlign="right"
                value={ITaxAmount}
              ></DPTextBoxforgrid>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Label htmlFor="example-text-input">
                <Label
                  htmlFor="example-text-input"
                  className={`col-md-12 col-form-label-sm`}
                >
                  Tax(Exclusive)
                </Label>
              </Label>
            </Col>
            <Col sm={6} style={{ textAlign: "right" }}>
              <DPTextBoxforgrid
                rowClass="mb-12-sm"
                labelText="Code"
                textType="text"
                maxLength="8"
                disabled={true}
                textAlign="right"
                value={ETaxAmount}
              ></DPTextBoxforgrid>
            </Col>
          </Row> */}
          <Row>
            <Col sm={6}>
              <Label htmlFor="example-text-input">
                <Label
                  htmlFor="example-text-input"
                  className={`col-md-12 col-form-label-sm`}
                >
                  Net Amount(Total Printing Cost)
                </Label>
              </Label>
            </Col>
            <Col sm={6} style={{ textAlign: "right" }}>
              <DPTextBoxforgrid
                rowClass="mb-12-sm"
                labelText="Code"
                textType="text"
                maxLength="8"
                disabled={true}
                textAlign="right"
                value={NetAmount}
              ></DPTextBoxforgrid>
            </Col>
          </Row>
        </Col>
      </Row>
    </React.Fragment >
  )
}


export default VoucherRequestDetails

const TableRow = ({ FormRow, Key, RemoveRow, Disabled, BookChange, SupplierCode, detailSearchCol, menuCode,
  HandleRowChanges, DataRow, SupplierTax, setSupplierTax, setTax, rowsTax, HandleTaxRowChange, AddRow,
  SetLoadingAlert, SetLoadingAlerttitle }) => {


  const [modal_xlarge, setmodal_xlarge] = useState(false)
  const [sweetAlertShow, setsweetAlertShow] = useState(false)
  const [AlertDescription, setAlertDescription] = useState(false)
  const [AlertConfirmOption, setAlertConfirmOption] = useState(0)

  const [Datatablesub, SetDatatablesub] = useState([])
  const [groupFilter, SetGroupFilter] = useState('a')
  //*** End of useStates */
  const ApiURL = window.Links.ApiURL


  async function clickSearch() {
    // if (SupplierCode == "") {
    //   setAlertDescription("Please Select Supplier First")
    //   setAlertConfirmOption(4)
    //   setsweetAlertShow(true)
    //   return
    // }

    tog_xlarge()

  }

  const Hed_SelectRowSearch = (e, row, isSelect, rowIndex) => {
    if (CodeValidation(row.VCG_CODE, 2)) {
      VoucherGroupCodeSearch(row.VCG_CODE)
      setmodal_xlarge(!modal_xlarge)
    }
    else {
      setAlertDescription("Code already used")
      setAlertConfirmOption(4)
      setsweetAlertShow(true)
    }
  }

  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ]

  function tog_xlarge() {
    setmodal_xlarge(!modal_xlarge)
    console.log("modal_xlarge", modal_xlarge)
  }

  function SetRowEmpty() {
    HandleRowChanges("", Key, "code")
    HandleRowChanges("", Key, "desc")
    HandleRowChanges(0, Key, "Cost")
    HandleRowChanges(0, Key, "Selling")
    HandleRowChanges(0, Key, "StartBook")
    HandleRowChanges(0, Key, "EndBook")
    HandleRowChanges(0, Key, "NoOfBook")
    HandleRowChanges(0, Key, "CostValue")
    HandleRowChanges(0, Key, "SellingValue")
    HandleRowChanges(0, Key, "rate")
  }

  async function VoucherGroupCodeSearch(value) {
    try {
      // Return early if value is empty
      if (!value) return;
  
      const ApiURL = window.Links.ApiURL;
      const authToken = localStorage.getItem("authToken");
  
      // Show loading alert
      SetLoadingAlert(true);
      SetLoadingAlerttitle("Loading Voucher Group Details");
  
      // Fetch data from API
      const response = await fetch(`${ApiURL}VoucherSale/Group/search/${value}`, {
        method: "GET",
        headers: { "Content-Type": "application/json", "Authorization": `Bearer ${authToken}` },
      });
  
      const responseData = await response.json();
  
      // Check if the response is successful
      if (responseData.success) {
        const newArray = responseData.data[0];
        
        // Handle row changes
        HandleRowChanges(newArray.strCode, Key, "code");
        HandleRowChanges(newArray.strName, Key, "desc");
        HandleRowChanges(newArray.dbCost, Key, "Cost");
        HandleRowChanges(parseFloat(newArray.dbValue).toFixed(2), Key, "Selling");
        HandleRowChanges(newArray.dbBookNo + 1, Key, "StartBook");
        HandleRowChanges(newArray.dbBookQty, Key, "rate");
        HandleRowChanges(0, Key, "EndBook");
        HandleRowChanges(0, Key, "NoOfBook");
        HandleRowChanges(0, Key, "CostValue");
        HandleRowChanges(0, Key, "SellingValue");
  
        // Focus on the field after row changes
        document.getElementById("txtNoOfBook" + Key).focus();
  
        // Update tax information
        const updatedTax = SupplierTax.map((item, index) => ({
          id: rowsTax.length === 0 ? 1 : rowsTax[rowsTax.length - 1].id + 1,
          code: newArray.strCode,
          desc: newArray.strName,
          TaxCode: item.TaxCode,
          grossAmt: 0,
          TaxRate: item.TaxRate,
          isInclude: item.isInclude,
          TaxAmount: 0,
        }));
  
        setTax([...rowsTax, ...updatedTax]);
      } else {
        // If the response is not successful, set the row to empty
        SetRowEmpty();
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      SetRowEmpty();
    } finally {
      // Hide loading alert
      SetLoadingAlert(false);
    }
  }
  


  const CodeValidation = (strCode, method) => {

    var filterItems = DataRow.filter(item => item.code == strCode)
    if (method == 1) {
      if (filterItems.length > 1) {
        return false
      }
    } else {
      if (filterItems.length > 0) {
        return false
      }
    }
    return true
  }

  return (
    <tr key={FormRow.id}>
      <td>
        {" "}
        <Row className="mb-1">
          <Col md="12">{Key + 1}</Col>
        </Row>
      </td>
      <td style={{ width: "90px" }}>
        <Row className="mb-1">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              maxLength="3"
              id={"txtcode" + Key}
              value={FormRow.code}
              disabled={FormRow.desc == "" ? false : true}
              onChange={e => {
                //setcode(e.target.value)
                HandleRowChanges(e.target.value, Key, "code")
              }}
              onBlur={e => {
                {
                  if (CodeValidation(e.target.value, 1)) {
                    VoucherGroupCodeSearch(e.target.value)
                  } else {
                    setAlertDescription("Code already used")
                    setAlertConfirmOption(4)
                    setsweetAlertShow(true)
                    HandleRowChanges("", Key, "code")
                  }
                }
              }}
              onKeyPress={e => {
                if (e.key === "Enter") {
                  // if (SupplierCode == "") {
                  //   setAlertDescription("Please Select Supplier First")
                  //   setAlertConfirmOption(4)
                  //   setsweetAlertShow(true)
                  // }
                  // else 

                  if (e.target.value == "") {
                    document.getElementById("btnSearch" + Key).focus()
                  } else if (CodeValidation(e.target.value, 1)) {
                    VoucherGroupCodeSearch(e.target.value)
                  } else {
                    setAlertDescription("Code already used")
                    setAlertConfirmOption(4)
                    setsweetAlertShow(true)
                    HandleRowChanges("", Key, "code")
                  }

                }
              }}
            />
          </Col>
        </Row>
      </td>
      <td>
        <Row className="mb-1">
          <Col md="12">
            <Button
              outline
              color="success"
              disabled={FormRow.desc == "" ? false : true}
              id={"btnSearch" + Key}
              onClick={clickSearch}
              size="sm"
            >
              <i
                className="mdi mdi-search-web"
                style={{ fontSize: "12px" }}
              ></i>
            </Button>
          </Col>
        </Row>
      </td>
      <td style={{ width: "200px" }}>
        <Row className="mb-1">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              maxLength="8"
              id={"txtdesc" + Key}
              value={FormRow.desc}
              disabled={true}

            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      {/* <td style={{ width: "100px" }}>
        <Row className="mb-1">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              textAlign="right"
              id={"txtCost" + Key}
              value={FormRow.Cost}
              disabled={true}

            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td> */}
      <td style={{ width: "140px", textAlign: "right" }}>
        <Row className="mb-1">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              textAlign="right"
              id={"txtSelling" + Key}
              value={FormRow.Selling}
              disabled={true}

            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      {/* <td style={{ width: "120px" }}>
        <Row className="mb-1">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              textAlign="right"
              id={"txtStartBook" + Key}
              value={FormRow.StartBook}
              disabled={true}

            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td> */}
      <td style={{ width: "100px" }}>
        <Row className="mb-1">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              textAlign="right"
              disabled={Disabled}
              id={"txtNoOfBook" + Key}
              value={FormRow.NoOfBook}
              onChange={e => {
                let valNoOfBook = Numeric(e.target, 8, 0, false)
                if (valNoOfBook == "") {
                  HandleRowChanges(0, Key, "NoOfBook")
                }
                else {
                  HandleRowChanges(valNoOfBook, Key, "NoOfBook")
                }
              }}
              onBlur={e => {

                if (FormRow.code != "") {

                  let valNoOfBook = Numeric(e.target, 8, 2, false)
                  if (valNoOfBook == "") {
                    HandleRowChanges(0, Key, "NoOfBook")
                  }
                  else {
                    HandleRowChanges(parseFloat(e.target.value, 10), Key, "NoOfBook")
                    HandleRowChanges(parseFloat(FormRow.StartBook) + parseFloat(e.target.value), Key, "EndBook")
                    HandleRowChanges(parseFloat(parseFloat(FormRow.Cost) * parseFloat(e.target.value)).toFixed(2), Key, "CostValue")
                    HandleRowChanges(parseFloat(parseFloat(FormRow.Selling) * parseFloat(FormRow.rate) * parseFloat(e.target.value)).toFixed(2), Key, "SellingValue")
                    HandleTaxRowChange(Key, FormRow.code, parseFloat(parseFloat(FormRow.Cost) * parseFloat(e.target.value) * parseFloat(FormRow.rate)).toFixed(2))

                    BookChange()
                  }
                } else {
                  setAlertDescription("Please Enter Code First")
                  setAlertConfirmOption(4)
                  setsweetAlertShow(true)
                  HandleRowChanges(0, Key, "NoOfBook")
                }
              }}
              onKeyPress={e => {
                if (e.key === "Enter") {
                  if (FormRow.code == "") {
                    setAlertDescription("Please Enter Code First")
                    setAlertConfirmOption(4)
                    setsweetAlertShow(true)
                    HandleRowChanges(0, Key, "NoOfBook")
                    return
                  }
                  if (e.target.value > 0) {

                    var emptyRow = DataRow.filter(x => x.code == "") // check is there any empty row

                    if (emptyRow.length > 0) return // if there is empty row then return

                    AddRow() // if there is no empty row then add new row
                    setTimeout(() => {
                      document.getElementById("txtcode" + (Key + 1)).focus() // focus on new row
                    }, 100);

                  } else {
                    setAlertDescription("Please Enter No Of Book")
                    setAlertConfirmOption(4)
                    setsweetAlertShow(true)
                  }
                }
              }}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      {/* <td style={{ width: "120px" }}>
        <Row className="mb-1">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              textAlign="right"
              id={"txtEndBook" + Key}
              value={FormRow.EndBook}
              disabled={true}

            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td> */}
      {/* <td style={{ width: "120px", margin: "auto" }}>
        <Row className="mb-1">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              textAlign="right"
              id={"txtCostValue" + Key}
              value={FormRow.CostValue}
              disabled={true}

            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td> */}
      <td style={{ width: "120px" }}>
        <Row className="mb-1">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              textAlign="right"
              id={"txtSellingValue" + Key}
              value={FormRow.SellingValue}
              disabled={true}

            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td>
        <Row className="mb-1">
          <Col md="1">
            <Button
              outline
              disabled={Disabled}
              color="danger"
              onClick={e => {
                RemoveRow(FormRow.id, FormRow.code)
              }}
              size="sm"
            >
              <i className="mdi mdi-delete" style={{ fontSize: "12px" }}></i>
            </Button>
          </Col>{" "}
        </Row>
      </td>

      <DPSearchBoxDynamicHeadOffice
        searchData={Datatablesub}
        columns={detailSearchCol}
        defaultSorted={defaultSorted}
        mainTitle={"Voucher Group Detail Search"}
        SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
        isOpen={modal_xlarge}
        toggle={tog_xlarge}
        getSelect={Hed_SelectRowSearch}
        APIURL={ApiURL}
        URLPath={"VOUGRP"}
        MenuCode={menuCode}
        KeyVal={'GRP'}
        searchBy={'VCG_CODE'}
        FilterStr={groupFilter}
      />
      <DPAlert
        confirm_both={sweetAlertShow}
        title={"Voucher Request Order !"}
        description={AlertDescription}
        showCancel={false}
        btnColor={"success"}
        cancelColor={"danger"}
        onConfirm={() => {
          setsweetAlertShow(false)
        }}
        btnYes={"OK"}
      />
    </tr>
  )
}
const TableTaxRow = ({ FormRow, Key }) => {
  return (
    <tr key={FormRow.id}>
      <td style={{ width: "80px" }}>
        <Row className="mb-1">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              textAlign="left"
              disabled={true}
              id={"txtVGroupCode" + Key}
              value={FormRow.code}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "200px" }}>
        <Row className="mb-1">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              disabled={true}
              textAlign="left"
              id={"txtVGroupName" + Key}
              value={FormRow.desc}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "80px" }}>
        <Row className="mb-1">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              disabled={true}
              textAlign="left"
              id={"txtTax" + Key}
              value={FormRow.TaxCode}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "100px" }}>
        <Row className="mb-1">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              disabled={true}
              textAlign="right"
              id={"txtGrossAmt" + Key}
              value={FormRow.grossAmt}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "100px" }}>
        <Row className="mb-1">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              disabled={true}
              textAlign="right"
              id={"txtTaxRate" + Key}
              value={FormRow.TaxRate}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "100px" }}>
        <Row className="mb-1">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              disabled={true}
              textType="text"
              textAlign="left"
              id={"txtIsInclude" + Key}
              value={FormRow.isInclude == 1 ? "Yes" : "No"}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "100px" }}>
        <Row className="mb-1">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              disabled={true}
              textAlign="right"
              id={"txtTaxAmount" + Key}
              value={FormRow.TaxAmount}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
    </tr>
  )
}
